import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Assuming React Router is used
import { ReactComponent as Tiktok } from "../../assets/images/svgs/tiktok.svg";
import { ReactComponent as Facebook } from "../../assets/images/svgs/facebook.svg";
import { ReactComponent as Instagram } from "../../assets/images/svgs/instagram.svg";
import { ReactComponent as Youtube } from "../../assets/images/svgs/youtube.svg";
import { ReactComponent as AppStore } from "../../assets/images/svgs/appStore.svg";
import { ReactComponent as PlayStore } from "../../assets/images/svgs/googlePlay.svg";
import FooterLogo from "../../assets/images/others/host-side-images/FooterLOgo.png";
import CustomerSupport from "../drawers/CustomerSupport";
import TermsAndCondition from "../drawers/host-side/TermsAndCondtion";
import PrivacyPolicy from "../drawers/host-side/PrivacyPolicy";
type DrawerType = "terms" | "privacy" | "contact" | null;
const HostFooter: React.FC = () => {
  const navigate = useNavigate();
  const [activeDrawer, setActiveDrawer] = useState<DrawerType>(null);

  const openDrawer = (drawer: Exclude<DrawerType, null>): void => {
    setActiveDrawer(drawer);
  };

  const closeDrawer = (): void => {
    setActiveDrawer(null);
  };
  return (
    <div className="bg-footerBg">
      <div className="container mx-auto flex flex-wrap sm:flex-nowrap items-center gap-8 sm:gap-28">
        {/* Left Section */}
        <div className="flex flex-col gap-6">
          <span>
            <img src={FooterLogo} alt="Footer Logo" className="mb-4" />
          </span>
          <p className="text-center lg:text-left text-footerText text-sm max-w-md">
            Together, we can support every business, inspire every child, and
            connect every community.
          </p>
        </div>

        {/* Middle Section: Social Media */}
        <div className="flex flex-col mt-8">
          <h4 className="text-footerText font-semibold mb-4">
            Follow our journey on social media
          </h4>
          <div className="flex space-x-4 justify-center lg:justify-start mb-6">
            <div role="button" className="cursor-pointer">
              <Tiktok />
            </div>
            <div role="button" className="cursor-pointer">
              <Facebook />
            </div>
            <div role="button" className="cursor-pointer">
              <Instagram />
            </div>
            <div role="button" className="cursor-pointer">
              <Youtube />
            </div>
          </div>

          <div className="flex space-x-4 justify-center lg:justify-start mt-6">
            <div role="button" className="cursor-pointer">
              <a
                href="https://play.google.com/store/apps/details?id=learnlocal.com&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PlayStore className="w-32 h-auto" />
              </a>
            </div>
            <div role="button" className="cursor-pointer">
              <a
                href="https://apps.apple.com/us/app/learn-local/id6745400502"
                target="_blank"
                rel="noopener noreferrer"
              >
                <AppStore className="w-32 h-auto" />
              </a>
            </div>
          </div>
        </div>

        {/* Right Section: App Store Links */}
      </div>

      {/* Bottom Links */}
      <div className="bg-primaryBlueText mt-8">
        <div className="container mx-auto py-4 px-4 flex flex-col items-center lg:flex-row justify-center text-sm text-white gap-4 md:gap-10">
          <p className="text-center lg:text-left mb-4 lg:mb-0">
            ©2025 Learn Local
          </p>
          <div className="flex whitespace-nowrap flex-wrap space-x-4">
            <button
              onClick={() => openDrawer("terms")}
              className="hover:underline"
            >
              Terms of Service
            </button>
            <button
              onClick={() => openDrawer("privacy")}
              className="hover:underline"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => openDrawer("contact")}
              className="hover:underline"
            >
              Contact us
            </button>
          </div>
        </div>
      </div>
      {/* Drawer */}
      {activeDrawer && (
        <div className="">
          {activeDrawer === "terms" && (
            <TermsAndCondition
              isOpen={activeDrawer === "terms"}
              onClose={closeDrawer}
            />
          )}
          {activeDrawer === "privacy" && (
            <PrivacyPolicy
              isOpen={activeDrawer === "privacy"}
              onClose={closeDrawer}
            />
          )}
          {activeDrawer === "contact" && (
            <CustomerSupport
              isOpen={activeDrawer === "contact"}
              onClose={closeDrawer}
            />
          )}
          <button
            onClick={closeDrawer}
            className="mt-4 text-blue-500 hover:underline"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default HostFooter;
